/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hero_LocationInputs */

const et_hero_location = /** @type {(inputs: Hero_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallinn, Eesti`)
};

const en_hero_location = /** @type {(inputs: Hero_LocationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tallinn, Estonia`)
};

/**
* | output |
* | --- |
* | "Tallinn, Estonia" |
*
* @param {Hero_LocationInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const hero_location = /** @type {((inputs?: Hero_LocationInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hero_LocationInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_hero_location(inputs)
	return en_hero_location(inputs)
});